import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "SAML SSO is now available",
  "description": "SAML Single Sign-on (SSO) is now available to Enterprise customers thanks to our friends over at WorkOS.",
  "date": "2021/08/03",
  "tag": "web development",
  "ogImage": "/images/blog/saml-sso-now-available/x-card.png"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Thanks to our friends over at WorkOS, in addition to GitHub, GitLab, and Passwordless auth, Turborepo now supports Single Sign-on (SSO) from the following SAML providers for enterprise customers:"
  }, {
    "heading": "",
    "content": "AD FS SAML"
  }, {
    "heading": "",
    "content": "Auth0 SAML"
  }, {
    "heading": "",
    "content": "Azure AD SAML"
  }, {
    "heading": "",
    "content": "CyberArk SAML"
  }, {
    "heading": "",
    "content": "Generic SAML"
  }, {
    "heading": "",
    "content": "G Suite OAuth"
  }, {
    "heading": "",
    "content": "G Suite SAML"
  }, {
    "heading": "",
    "content": "JumpCloud SAML"
  }, {
    "heading": "",
    "content": "Microsoft OAuth"
  }, {
    "heading": "",
    "content": "Okta SAML"
  }, {
    "heading": "",
    "content": "OneLogin SAML"
  }, {
    "heading": "",
    "content": "OpenID Connect"
  }, {
    "heading": "",
    "content": "PingFederate SAML"
  }, {
    "heading": "",
    "content": "PingOne SAML"
  }, {
    "heading": "",
    "content": "Shibboleth"
  }, {
    "heading": "",
    "content": "VMWare SAML"
  }, {
    "heading": "",
    "content": "We also support SCIM (a.k.a. \"Directory Sync\") via:"
  }, {
    "heading": "",
    "content": "Azure AD SCIM"
  }, {
    "heading": "",
    "content": "BambooHR"
  }, {
    "heading": "",
    "content": "G Suite"
  }, {
    "heading": "",
    "content": "Gusto"
  }, {
    "heading": "",
    "content": "Hibob"
  }, {
    "heading": "",
    "content": "Okta SCIM v1.1"
  }, {
    "heading": "",
    "content": "Okta SCIM v2.0"
  }, {
    "heading": "",
    "content": "Rippling"
  }, {
    "heading": "",
    "content": "SCIM v1.1"
  }, {
    "heading": "",
    "content": "SCIM v2.0"
  }, {
    "heading": "",
    "content": "Workday"
  }, {
    "heading": "",
    "content": "If you're team in interested in activating SAML SSO, please contact us turborepo@vercel.com."
  }, {
    "heading": "whats-next",
    "content": "We take security extremely seriously. And while SSO is certainly a must in 2021, we are also currently undergoing a third-party SOC 2 Type 2 examination as well. Last but not least, we are adding biometric/U2F access controls and audit logs this fall. Stay tuned for updates."
  }],
  "headings": [{
    "id": "whats-next",
    "content": "What's next?"
  }]
};
import {Authors} from '#components/authors';
export const toc = [{
  depth: 2,
  url: "#whats-next",
  title: _jsx(_Fragment, {
    children: "What's next?"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "SAML SSO is now available"
    }), "\n", "\n", _jsx(Authors, {
      authors: ['jaredpalmer']
    }), "\n", _jsxs(_components.p, {
      children: ["Thanks to our friends over at ", _jsx(_components.a, {
        href: "https://workos.com/",
        children: "WorkOS"
      }), ", in addition to GitHub, GitLab, and Passwordless auth, Turborepo now supports Single Sign-on (SSO) from the following SAML providers for enterprise customers:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "AD FS SAML"
      }), "\n", _jsx(_components.li, {
        children: "Auth0 SAML"
      }), "\n", _jsx(_components.li, {
        children: "Azure AD SAML"
      }), "\n", _jsx(_components.li, {
        children: "CyberArk SAML"
      }), "\n", _jsx(_components.li, {
        children: "Generic SAML"
      }), "\n", _jsx(_components.li, {
        children: "G Suite OAuth"
      }), "\n", _jsx(_components.li, {
        children: "G Suite SAML"
      }), "\n", _jsx(_components.li, {
        children: "JumpCloud SAML"
      }), "\n", _jsx(_components.li, {
        children: "Microsoft OAuth"
      }), "\n", _jsx(_components.li, {
        children: "Okta SAML"
      }), "\n", _jsx(_components.li, {
        children: "OneLogin SAML"
      }), "\n", _jsx(_components.li, {
        children: "OpenID Connect"
      }), "\n", _jsx(_components.li, {
        children: "PingFederate SAML"
      }), "\n", _jsx(_components.li, {
        children: "PingOne SAML"
      }), "\n", _jsx(_components.li, {
        children: "Shibboleth"
      }), "\n", _jsx(_components.li, {
        children: "VMWare SAML"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "We also support SCIM (a.k.a. \"Directory Sync\") via:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Azure AD SCIM"
      }), "\n", _jsx(_components.li, {
        children: "BambooHR"
      }), "\n", _jsx(_components.li, {
        children: "G Suite"
      }), "\n", _jsx(_components.li, {
        children: "Gusto"
      }), "\n", _jsx(_components.li, {
        children: "Hibob"
      }), "\n", _jsx(_components.li, {
        children: "Okta SCIM v1.1"
      }), "\n", _jsx(_components.li, {
        children: "Okta SCIM v2.0"
      }), "\n", _jsx(_components.li, {
        children: "Rippling"
      }), "\n", _jsx(_components.li, {
        children: "SCIM v1.1"
      }), "\n", _jsx(_components.li, {
        children: "SCIM v2.0"
      }), "\n", _jsx(_components.li, {
        children: "Workday"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["If you're team in interested in activating SAML SSO, please contact us ", _jsx(_components.a, {
        href: "mailto:turborepo@vercel.com",
        children: "turborepo@vercel.com"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "whats-next",
      children: "What's next?"
    }), "\n", _jsx(_components.p, {
      children: "We take security extremely seriously. And while SSO is certainly a must in 2021, we are also currently undergoing a third-party SOC 2 Type 2 examination as well. Last but not least, we are adding biometric/U2F access controls and audit logs this fall. Stay tuned for updates."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
